import { Component, OnInit } from '@angular/core';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { IndustryProductID } from 'src/app/model/industry';

@Component({
    selector: 'ms-magocloud-dashboard',
    templateUrl: './magocloud-dashboard.component.html',
    styleUrls: ['./magocloud-dashboard.component.scss'],
})
export class MagocloudDashboardComponent implements OnInit {
    public productID: string = IndustryProductID.MC;

    constructor(public navigateService: NavigateService, private magoCloudService: MagoCloudService) {}
    ngOnInit(): void {}

    public navigate() {
        this.navigateService.goToManagement();
    }

    public navigateToHome() {
        this.navigateService.goToHomePage();
    }
}
